export const MAX_CANVAS_SIZE = 16777216;

export const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$/;

export const recaptchaKey = "6Le5hkocAAAAAOm9I8pZVVm9-8NOWpt9_6ZLy4og";
